import {
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FileDownloaderService,
  IFileDownloaderTick,
} from './services/file-downloader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { FileDownloaderRowComponent } from './components';
import { TranslateModule } from '@ngx-translate/core';

@UntilDestroy()
@Component({
  selector: 'app-file-downloader',
  standalone: true,
  imports: [CommonModule, FileDownloaderRowComponent, TranslateModule],
  templateUrl: './file-downloader.component.html',
  styleUrls: ['./file-downloader.component.scss'],
})
export class FileDownloaderComponent implements OnInit {
  @ViewChild('template') template!: TemplateRef<NzSafeAny>;
  public isOpened = false;
  public ticks: IFileDownloaderTick[] = [];

  private readonly _fileDownloaderService = inject(FileDownloaderService);
  private readonly _notification = inject(NzNotificationService);

  ngOnInit(): void {
    this._downloadTickSubscription();
  }

  public close(): void {
    this._notification.remove('file-downloader');
    this.isOpened = false;
    this.ticks = [];
  }

  private _downloadTickSubscription(): void {
    this._fileDownloaderService.downloadTick$
      .pipe(untilDestroyed(this))
      .subscribe(data => {
        if (!this.isOpened) {
          this._createPopup();
        }

        this.isOpened = true;
        this.ticks.push(data);
      });
  }

  private _createPopup(): void {
    this._notification.template(this.template, {
      nzPlacement: 'bottomRight',
      nzDuration: 0,
      nzKey: 'file-downloader',
      nzStyle: {
        width: '300px',
        margin: 0,
      },
      nzClass: 'file-downloader-popup',
    });
  }
}
